<template>
  <div
    class="reply-by-template bg-neutral-50 px-4 pb-4 pt-2 border-t border-neutral-200"
  >
    <div class="reply-mode-tabs">
      <button
        class="reply-mode-btn"
        :class="{ 'reply-mode-btn--active': !isPrivateMode }"
        @click="setReplyMode('REPLY')"
      >
        <span class="material-symbols-outlined reply-mode-icon"> chat </span>
      </button>
      <button
        class="reply-mode-btn"
        :class="{ 'reply-mode-btn--note-active': isPrivateMode }"
        @click="setReplyMode('NOTE')"
      >
        <span class="material-symbols-outlined reply-mode-icon"> draft </span>
      </button>
    </div>
    <div class="text-base font-normal text-gray-600 mb-3">
      {{ $t('CONVERSATION.REPLYBOX.START_NEW_CONVERSATION_WITH_TEMPLATE') }}
    </div>
    <button
      v-if="hasInboxPermission('Inbox reply')"
      class="button-outline flex items-center gap-1 px-5 py-3"
      @click.prevent="openWhatsappTemplateModal"
    >
      <span class="flex items-center justify-center">
        <span
          class="icon-mask w-6 h-6 bg-green-500"
          :style="{
            '-webkit-mask-image': `url(${whatsappBadge})`,
            'mask-image': `url(${whatsappBadge})`,
          }"
        />
      </span>
      <span class="text-base text-green-500 font-normal">
        {{ $t('WHATSAPP_TEMPLATES.MODAL.BUTTON_TO_OPEN_TITLE') }}
      </span>
    </button>
  </div>
</template>
<script>
import hasPermissionMixin from 'dashboard/mixins/hasPermission';
import whatsappBadge from 'dashboard/assets/images/inbox_icons/whatsapp-badge-nocolor.svg';

export default {
  mixins: [hasPermissionMixin],
  inject: ['isPrivateMode', 'setReplyMode', 'openWhatsappTemplateModal'],
  data() {
    return {
      whatsappBadge,
    };
  },
};
</script>
<style lang="scss" scoped>
.reply-mode-tabs {
  display: flex;
  width: fit-content;
  gap: 4px;
  padding: 4px;
  background: #ffffff;
  border: 1px solid #f3f4f6;
  border-radius: 6px;
  margin-bottom: 4px;
}
.reply-mode-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: none;
  border-radius: 5px;
  background: transparent;
  cursor: pointer;
  padding: 4px;
  color: #9ca3af;
  transition: background 0.15s ease, color 0.15s ease;

  &:hover {
    background: #f3f4f6;
    color: #6b7280;
  }

  &--active {
    background: #2abb7f;
    color: #ffffff;

    &:hover {
      background: #23a870;
      color: #ffffff;
    }
  }

  &--note-active {
    background: #fef9c3;
    color: #a16207;

    &:hover {
      background: #fef08a;
      color: #92400e;
    }
  }
}

.reply-mode-icon {
  font-size: 16px;
  line-height: 1;
  font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 16;
}
</style>
